const menuButton = document.querySelector('.mobile-menu');
const mobileDrawer = document.querySelector('.mobile-drawer');
if (menuButton && mobileDrawer) {
  menuButton.addEventListener('click', () => {
    const open = !mobileDrawer.hasAttribute('hidden');
    if (open) mobileDrawer.setAttribute('hidden',''); else mobileDrawer.removeAttribute('hidden');
    menuButton.setAttribute('aria-expanded', String(!open));
  });
}

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const showMedia = (id) => {
    const panel = section.querySelector('.product-gallery__panel[data-media-id="' + id + '"]');
    if (!panel) return;
    section.querySelectorAll('.product-gallery__panel').forEach(p => p.classList.toggle('is-active', p === panel));
    section.querySelectorAll('.product-thumb').forEach(t => t.classList.toggle('is-active', t.dataset.mediaTarget === id));
  };

  const form = section.querySelector('[data-product-form]');
  const json = section.querySelector('[data-product-variants]');
  if (form && json) {
    const variants = JSON.parse(json.textContent);
    const idInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-to-bag]');
    const price = section.querySelector('[data-product-price]');
    const groups = [...form.querySelectorAll('[data-option-index]')];
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency: window.Shopify?.currency?.active || 'USD'}).format(cents/100);
    const selectedOptions = () => groups.map(group => group.querySelector('.variant-pill.is-selected')?.dataset.optionValue);
    const syncVariant = () => {
      const options = selectedOptions();
      const variant = variants.find(v => v.options.every((option, i) => option === options[i]));
      if (!variant) { addButton.disabled = true; addButton.textContent = 'Unavailable'; return; }
      idInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (variant.featured_image) showMedia(String(variant.featured_image.id));
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to bag' : 'Sold out';
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
    };
    const initial = variants.find(v => String(v.id) === String(idInput.value));
    if (initial && initial.featured_image) showMedia(String(initial.featured_image.id));
    groups.forEach(group => group.querySelectorAll('.variant-pill').forEach(button => button.addEventListener('click', () => {
      group.querySelectorAll('.variant-pill').forEach(b => b.classList.remove('is-selected'));
      button.classList.add('is-selected');
      syncVariant();
    })));
  }

  section.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => {
    const target = button.dataset.mediaTarget;
    section.querySelectorAll('.product-gallery__panel').forEach(panel => panel.classList.toggle('is-active', panel.dataset.mediaId === target));
    section.querySelectorAll('.product-thumb').forEach(thumb => thumb.classList.toggle('is-active', thumb === button));
  }));
});
